import { collection, doc, serverTimestamp, setDoc, Timestamp } from 'firebase/firestore'
import { type MealLogInput, mealLogFields } from '@/types/mealLog'
import { db } from './config'

// Add a note or a cook to a meal's log, returning the new entry's ID. Dated now unless `cookedOn` says otherwise.
export async function addMealLogEntry(uid: string, input: MealLogInput, cookedOn?: Date): Promise<string> {
  const fields = mealLogFields(input)
  if (!fields) throw new Error('A meal log entry needs a note or a cook')
  const ref = doc(collection(db, 'users', uid, 'meal_log'))
  await setDoc(ref, { ...fields, createdAt: cookedOn ? Timestamp.fromDate(cookedOn) : serverTimestamp() })
  return ref.id
}
